import axios from "axios";

import { TRADING_API_URL } from "../../config/apiConfig";

/**
 * Page /speculators — offres exceptionnelles des producteurs et cours de marché
 * (sales-and-market-tracking, analysés par son service interne price-tracker).
 *
 *   GET /market/exceptional-offers?country=TG&subCategory=&page=&size=   public, sans JWT
 *   GET /market/prices?country=TG                                        public, sans JWT
 *
 * Écart, économie, tendance et score sont calculés par le backend ; le frontend ne connaît
 * aucun prix ni aucun cours.
 */
// Lecture publique : jamais de JWT (un jeton expiré la ferait échouer en 401).
const api = axios.create({ baseURL: TRADING_API_URL, timeout: 20000 });

/** @param {{country: string, subCategory?: string, page?: number, size?: number}} query */
export const listExceptionalOffers = async ({ country, subCategory, page = 0, size = 12 }) => {
    const { data } = await api.get("/market/exceptional-offers", {
        params: { country, subCategory: subCategory || undefined, page, size }
    });
    return {
        items: data?.items || [],
        page: data?.page ?? page,
        size: data?.size ?? size,
        total: data?.total ?? 0,
        comparedOffers: data?.comparedOffers ?? 0,
        thresholdPercent: data?.thresholdPercent ?? null
    };
};

export const listMarketPrices = async (country) => {
    const { data } = await api.get("/market/prices", { params: { country } });
    return Array.isArray(data) ? data : [];
};

const marketApi = { listExceptionalOffers, listMarketPrices };

export default marketApi;
